<cap-content-header>
  <cap-title>
    {{ "personstamm.ListTitel" | translate }}
  </cap-title>
  <cap-title-functionbar>
    <cap-functionbar-searchresult-buttons [listLoader]="personLoader"></cap-functionbar-searchresult-buttons>
  </cap-title-functionbar>
</cap-content-header>

@if (personResponse) {
  <cap-list-loader [listLoader]="personLoader" [showZeilenSelect]="false">
    <div class="cap-list-loader-title">
      <ng-content select="[name=title]"></ng-content>
    </div>
    <div class="cap-list-loader-content">
      <table class="cap-table-search">
        <thead>
          <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
        </thead>
        <tbody>
          <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
        </tbody>
      </table>
    </div>
  </cap-list-loader>

  <ng-template #tableHeaders>
    <tr>
      <th>
        <cap-column-header [columnName]="'Bezeichnung'" [sortModel]="tableSortModel.columns.get('bezeichnung')"></cap-column-header>
      </th>
      <th>
        <cap-column-header [columnName]="'Art'" [sortModel]="tableSortModel.columns.get('art')"></cap-column-header>
      </th>
      <th>
        {{ "AdressenN" | translate }}
      </th>
      <th>
        <cap-column-header [columnName]="'AHV-Nr/UID'" [sortModel]="tableSortModel.columns.get('ahvNummer')"></cap-column-header>
      </th>
      @if (personResponse.results[0]?.mFremdId.access != "NONE") {
        <th>
          <cap-column-header [columnName]="'zentraleNr'" [sortModel]="tableSortModel.columns.get('zentraleNummer')"></cap-column-header>
        </th>
      }
      <th>
        <cap-column-header [columnName]="'personstamm.GrundbuchBezug'" [sortModel]="tableSortModel.columns.get('bezugGb')">
        </cap-column-header>
      </th>
    </tr>
  </ng-template>

  <ng-template #tableRows>
    @for (item of personLoader?.items; track item) {
      <tr>
        <td>
          @if (hasAuskunftsperre(item.auskunftsperre) && !hasPermissionAuskunft) {
            <div>
              <span style="font-style: italic">{{ "stammperson-auskunftsperre" | translate }}</span>
            </div>
          } @else if (showPersonendaten(item.auskunftsperre)) {
            @if (detailNavigationPossible) {
              <cap-link [params]="[item.fremdId]" [target]="navTargets.NAV_PERSON_ZPV" [tooltipParams]="{ person: item.bezeichnung }">
                <ng-template [ngTemplateOutlet]="bezeichnung"></ng-template>
              </cap-link>
            } @else {
              <ng-template [ngTemplateOutlet]="bezeichnung"></ng-template>
            }
          }
          <ng-template #bezeichnung>
            @if (hasAuskunftsperre(item.auskunftsperre) && hasPermissionAuskunft) {
              <div class="float-start me-2">
                <span
                  [ngbTooltip]="'stammperson-auskunftsperre-mitBerechtigung' | translate"
                  [placement]="'bottom'"
                  class="ms-1 fas fa-exclamation-triangle text-warning"></span>
              </div>
            }
            <div>
              {{ item.bezeichnung }}
            </div>
          </ng-template>
        </td>
        <td>
          @if (showPersonendaten(item.auskunftsperre)) {
            @if (detailNavigationPossible) {
              <cap-link [params]="[item.fremdId]" [target]="navTargets.NAV_PERSON_ZPV" [tooltipParams]="{ person: item.bezeichnung }">
                <ng-template [ngTemplateOutlet]="art"></ng-template>
              </cap-link>
            } @else {
              <ng-template [ngTemplateOutlet]="art"></ng-template>
            }
          }
          <ng-template #art>
            <div>
              {{ item.art | translate }}
            </div>
          </ng-template>
        </td>
        <td>
          @if (hasAdresssperre(item.auskunftsperre) && !hasPermissionAdresse) {
            <div>
              <span style="font-style: italic">{{ "stammperson-adresssperre" | translate }}</span>
            </div>
          } @else {
            @for (adresse of item.adressen; track adresse; let i = $index) {
              <cap-kompakt-personenadresse
                [auskunftsperre]="item.auskunftsperre"
                [entry]="item"
                [item]="adresse"></cap-kompakt-personenadresse>
              @if (i < item.adressen.length - 1) {
                <br />
              }
            }
          }
        </td>
        <td>
          @if (showPersonendaten(item.auskunftsperre)) {
            @if (detailNavigationPossible) {
              <cap-link [params]="[item.fremdId]" [target]="navTargets.NAV_PERSON_ZPV" [tooltipParams]="{ person: item.bezeichnung }">
                <ng-template [ngTemplateOutlet]="ahvNummer"></ng-template>
              </cap-link>
            } @else {
              <ng-template [ngTemplateOutlet]="ahvNummer"></ng-template>
            }
          }
          <ng-template #ahvNummer>
            {{ item.unternehmensId | formatUid }}
            {{ item.ahvNummer | formatAhv }}
          </ng-template>
        </td>
        @if (personResponse.results[0]?.mFremdId.access != "NONE") {
          <td>
            @if (showPersonendaten(item.auskunftsperre)) {
              @if (detailNavigationPossible) {
                <cap-link [params]="[item.fremdId]" [target]="navTargets.NAV_PERSON_ZPV" [tooltipParams]="{ person: item.bezeichnung }">
                  <ng-template [ngTemplateOutlet]="fremdId"></ng-template>
                </cap-link>
              } @else {
                <ng-template [ngTemplateOutlet]="fremdId"></ng-template>
              }
            }
            <ng-template #fremdId>
              {{ item.fremdId }}
            </ng-template>
          </td>
        }
        <td>
          @if (showPersonendaten(item.auskunftsperre)) {
            @if (detailNavigationPossible) {
              <cap-link [params]="[item.fremdId]" [target]="navTargets.NAV_PERSON_ZPV" [tooltipParams]="{ person: item.bezeichnung }">
                <ng-template [ngTemplateOutlet]="mitGrundbuchbezug"></ng-template>
              </cap-link>
            } @else {
              <ng-template [ngTemplateOutlet]="mitGrundbuchbezug"></ng-template>
            }
          }
          <ng-template #mitGrundbuchbezug>
            {{ item.mitGrundbuchbezug | yesNo }}
          </ng-template>
        </td>
      </tr>
    }
  </ng-template>
} @else {
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-1 text-center">
        <cap-spinner-small></cap-spinner-small>
      </div>
    </div>
  </div>
}
